import React, { Component } from 'react';
import styled from 'styled-components';
import { AUTH_CLI_BG } from '../../config/media';

const Wrapper = styled.div`
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	.bg-wrapper-text {
		width: 700px;
		position: absolute;
		top: 40%;
		left: 120px;
		z-index: 10;
		color: #fff;
		h2 {
			font-size: 32px;
			color: #fff;
			font-weight: bold;
		}
		p {
			font-size: 14px;
			line-height: 16px;
		}
		.btn-link {
			color: #fff;
			font-size: 10px;
			padding: 7px 14px;
			border: 2px solid #fff;
			text-decoration: none;
			font-weight: bold;
		}
	}
	.bg-wrapper-image {
		width: 100%;
		height: 100%;
		position: relative;
		z-index: 1;
		background-position: center;
		background-size: cover;
		background-image: url(${AUTH_CLI_BG});
	}
	/* .bg-cli-image {
		width: 28vw;
		height: 21vw;
		position: absolute;
		right: 5%;
		top: 50%;
		transform: translateY(-55%);
		z-index: 2;
		background-repeat: no-repeat;
		background-size: cover;
		background-image: url(${AUTH_CLI_BG});
	} */
	@media (max-width: 1300px) {
		.bg-wrapper-text {
			left: 60px;
		}
	}
	@media (max-width: 1200px) {
		.bg-wrapper-text {
			width: 650px;
			left: 30px;
			h2 {
				font-size: 20px;
			}
			p {
				font-size: 12px;
			}
		}
	}
`;

class Article extends Component {
	render() {
		return (
			<Wrapper>
				<div className="bg-cli-image"></div>
				<div className="bg-wrapper-image"></div>
				<div className="bg-wrapper-text">
					<h2>Watch Exchange Launch</h2>
					<p>
						Launch your own exchange and get your digital assets
						<br />
						to market fast with the HollaEx Kit.
					</p>
					<a
						href="https://www.youtube.com/watch?v=3TpzR3X7iRI&t=4s"
						title="bitholla"
						target="_blank"
						rel="noopener noreferrer"
						className="btn-link"
					>
						Watch Launch
					</a>
				</div>
			</Wrapper>
		);
	}
}

export default Article;
